import { render, staticRenderFns } from "./DealersRankingList.vue?vue&type=template&id=79155e62"
import script from "./DealersRankingList.vue?vue&type=script&lang=js"
export * from "./DealersRankingList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports